import React, { useState } from "react";
import Input from "../Input";

export default function InputCpf({
  value,
  onChange,
  onKeyDown,
  onPaste,
  ...props
}) {
  const [mask, setMask] = useState("999.999.999-99");
  const [inputValue, setInputValue] = useState(value);

  function handleChange(e) {
    setInputValue(e.target.value);
    onChange && onChange(e);
  }

  function clearString(e) {
    return e.replace(/[^\d]/gi, "");
  }

  function handleMask(event) {
    let key = event.key;
    let e = inputValue;
    let value = clearString(e);
    setMask("999.999.999-99");
    onKeyDown && onKeyDown(event);
  }

  function handlePaste(event) {
    let e = event.clipboardData.getData("Text");
    let value = clearString(e);
    setMask("999.999.999-99");
    event.target.value = value;
    handleChange(event);
    onPaste && onPaste(event);
  }

  return (
    <Input
      mask={mask}
      {...props}
      onChange={handleChange}
      onKeyDown={handleMask}
      onPaste={handlePaste}
      value={inputValue}
    ></Input>
  );
}
